import { render, staticRenderFns } from "./EssayResult.vue?vue&type=template&id=6aca5b84&scoped=true&"
import script from "./EssayResult.vue?vue&type=script&lang=ts&"
export * from "./EssayResult.vue?vue&type=script&lang=ts&"
import style0 from "./EssayResult.vue?vue&type=style&index=0&id=6aca5b84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aca5b84",
  null
  
)

export default component.exports